import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useOverlaySSE from './useOverlaySSE';
import { formatRupiah } from '../../lib/api';
import api from '../../lib/api';
import './overlay.css';

export default function OverlayGoal() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [goals, setGoals] = useState([]);
  const accentColor = searchParams.get('accent') || '#FF6B35';

  const fetchGoals = useCallback(async () => {
    try {
      const res = await api.get(`/overlay/goals/${token}`);
      setGoals(res.data || []);
    } catch {}
  }, [token]);

  useEffect(() => { fetchGoals(); }, [fetchGoals]);

  const handleEvent = useCallback((event) => {
    if (event.type === 'donation') {
      // Refetch goals on any donation
      fetchGoals();
    }
  }, [fetchGoals]);

  useOverlaySSE(token, handleEvent);

  if (goals.length === 0) return <div className="overlay-container" />;

  const g = goals[0]; // Show first active goal
  const pct = Math.min(100, Math.round((g.current_amount / g.target_amount) * 100)) || 0;

  return (
    <div className="overlay-container" style={{ '--ov-accent': accentColor }}>
      <div className="goal-container">
        <div className="goal-card">
          <div className="goal-title">🎯 {g.title}</div>
          <div className="goal-bar-bg">
            <div className="goal-bar-fill" style={{ width: `${pct}%` }}>
              {pct >= 10 && <span className="goal-percent">{pct}%</span>}
            </div>
          </div>
          <div className="goal-amounts">
            <span>{formatRupiah(g.current_amount)}</span>
            <span>{formatRupiah(g.target_amount)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
